import { render, staticRenderFns } from "./zhuanyeDialog.vue?vue&type=template&id=0f34a2a4&scoped=true"
import script from "./zhuanyeDialog.vue?vue&type=script&lang=js"
export * from "./zhuanyeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f34a2a4",
  null
  
)

export default component.exports